import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { CombinedAnalyzeRequest, CombinedAnalyzeResponse } from './types';

function useDebounced<T>(value: T, ms = 200): T {
  const [d, setD] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setD(value), ms);
    return () => window.clearTimeout(id);
  }, [value, ms]);
  return d;
}

export function useCombinedAnalysis(request: CombinedAnalyzeRequest) {
  const debounced = useDebounced(request, 200);
  return useQuery<CombinedAnalyzeResponse>({
    queryKey: ['zapatas', 'combined', 'analyze', debounced],
    queryFn: async () => {
      const { data } = await api.post<CombinedAnalyzeResponse>(
        '/api/zapatas/combined/analyze',
        debounced,
      );
      return data;
    },
    placeholderData: (prev) => prev,
    retry: 0,
  });
}
